<template>
  <div
    class="flex-cc"
  >
    <Dropdown
      trigger="click"
      class="menber-center-menu"
    >
      <a href="javascript:void(0)">    
        <Icon
          type="ios-home"
          size="20"
          color="#e0e0e0"
        />
        <span v-text="`會員中心`" />
      </a>
      <DropdownMenu slot="list">
        <DropdownItem
          v-for="item in MeberDropdownItems"
          :key="item.name"
        >
          <router-link
            v-if="item.name"
            :to="{name: item.name}"
            v-text="item.text"
          />
          <p
            v-else
            @click="handleLogout"
            v-text="item.text"
          />
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
    <Dropdown
      trigger="click"
      class="sign-in-menu"
    >
      <a href="javascript:void(0)">
        <Icon
          type="android-person"
          size="20"
          color="#e0e0e0"
        />
        <span v-text="fullName" />
      </a>
      <DropdownMenu slot="list">
        <DropdownItem
          v-for="item in LogoutDropdownItems"
          :key="item.name"
        >
          <router-link
            v-if="item.name"
            :to="{name: item.name}"
            v-text="item.text"
          />
          <p
            v-else
            @click="handleLogout"
            v-text="item.text"
          />
        </DropdownItem>
      </DropdownMenu>
  </Dropdown>    
<div>
<router-link 
      :to="{path:'/help'}"      
    >
    <img 
    style="max-width:20px;min-width:15px;margin-left:10px;" 
    width="100%" 
    src="@/assets/information.png">
    </router-link>
</div>
</div>
</template>

<script>
  import {
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Icon,
  } from 'iview';
  import { LogoutDropdownItems } from '@/staticData/userSettings';
  import { MeberDropdownItems } from '@/staticData/userSettings';

  export default {
    components: {
      Dropdown,
      DropdownMenu,
      DropdownItem,
      Icon
    },
    props: {
      handleLogout: {
        type: Function,
        default: () => {}
      },
      fullName: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        LogoutDropdownItems,
        MeberDropdownItems
      };
    }
  };
</script>

